// 产品编码归一化（前端单一数据源）
// 与后端 server/database.js 的 isQtyTail / parentOf 严格一致，禁止改动后与后端漂移。
// 规格编码 → 上级产品编码：优先特殊映射，其次按"数量段"判定去尾。

// 数量段特征：最后一段是"整百/整千/整万"等常见数量才视为规格后缀
const QTY_SET = new Set([100, 200, 300, 400, 500, 600, 800, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 8000, 10000, 12000, 15000, 20000, 30000, 50000]);

// 特殊编码映射：末尾数字非标准数量段，但业务上需归属到指定上级（逐个登记，不影响其他编码）
const SPECIAL_PARENT = { 'JZ-白管80g卷纸-160': 'JZ-白管80g卷纸' };

function isQtyTail(code) {
  const m = String(code || '').match(/-(\d+)$/);
  if (!m) return false;
  const q = Number(m[1]);
  return QTY_SET.has(q) || (q > 0 && q % 1000 === 0);
}

// 规格编码 → 上级产品编码：如 HB-0001-蓝-1000 → HB-0001-蓝；HB-0001-1000 → HB-0001；
// 末尾数字非数量段时原样保留（如型号 -160 靠 SPECIAL_PARENT 登记，未登记的保留完整编码）
export function prodCode(code) {
  const s = String(code || '').trim();
  if (!s) return s;
  if (SPECIAL_PARENT[s]) return SPECIAL_PARENT[s];
  return isQtyTail(s) ? s.replace(/-\d+$/, '') : s;
}

export { isQtyTail, SPECIAL_PARENT };
